module.exports = __webpack_public_path__ + "static/szirenLogo-62f78758cb31c25a90b612ce9fbd8dbc.png";